"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

var _Utils = require("./Utils");

/**
 * @class
 * @classdesc TreeFlatten <br/>
 * This Object is treated as a class so the usage would be 'new common.TreeFlatten()'
 * @constructor
 * @see aDataGrid
 * @see aDataGrid.useTree
 */
function TreeFlatten() {
  var treeField = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'children';
  this.treeField = treeField;
}
/**
 * Crea una lista flat a partire da un tree sul campo indicato nel costruttore (se omesso, default 'children').
 * Per ogni riga in uscita aggiunge un sotto-oggetto _tree con le informazioni necessarie 
 * SENZA creare il sotto-campo (property) .level.
 * 
 * @param {*} treeObject l'oggetto tree di partenza
 * @param {*} objidFunc funzione per calcolare su un oggetto un id univoco (non required)
 * @returns array delle righe compatibile con la modalità tree di aDataGrid
 */


TreeFlatten.prototype.flattenTree = function (treeObject, objidFunc) {
  return this._flatten((0, _lodash.cloneDeep)(treeObject), 0, objidFunc, undefined, true);
};
/**
 * Crea una lista flat a partire da un tree sul campo indicato nel costruttore (se omesso, default 'children').
 * Per ogni riga in uscita aggiunge un sotto-oggetto _tree con le informazioni necessarie 
 * creando anche la property .level legata al ._tree.level, per retrocompatibilità.
 * 
 * @param {*} treeObject l'oggetto tree di partenza
 * @param {*} lev livello di partenza (non usato, esiste per retrocompatibilità)
 * @param {*} objidFunc funzione per calcolare su un oggetto un id univoco (non required)
 */


TreeFlatten.prototype.flatten = function (treeObject, lev, objidFunc) {
  return this._flatten((0, _lodash.cloneDeep)(treeObject), 0, objidFunc, undefined, false);
};
/**
 * Elimina le inforamzioni di tree dalla lista (precedentemente creata con i metodi flatten()/flattenTree()) 
 * e restituendo un albero costruito sulla base del campo passato nel costruttore (default 'children')
 * 
 * @param {*} list 
 * @returns {*} oggetto tree
 */


TreeFlatten.prototype.unflatten = function (list) {
  if (!list) return null;
  list = (0, _lodash.cloneDeep)(list);
  var tree = list[0];

  if (!tree || tree._tree === undefined || tree._tree.level !== 0) {
    console.error("non convertibile in tree, il primo elemento deve essree quello di livello 0");
    return null;
  }

  tree = this._removeTreeFields(tree, false);

  this._unflatten(list, tree, 1, 1, false);

  return tree;
};
/**
 * Elimina le inforamzioni di tree dalla lista (precedentemente creata con i metodi flatten()/flattenTree()) 
 * e restituendo un albero costruito sulla base del campo passato nel costruttore (default 'children')
 * SENZA considereare il campo .level ()
 * @param {*} list 
 * @returns {*} oggetto tree
 */


TreeFlatten.prototype.unflattenTree = function (list) {
  if (!list) return null;
  list = (0, _lodash.cloneDeep)(list);
  var tree = list[0];

  if (!tree || tree._tree === undefined || tree._tree.level !== 0) {
    console.error("non convertibile in tree, il primo elemento deve essree quello di livello 0");
    return null;
  }

  tree = this._removeTreeFields(tree, true);

  this._unflatten(list, tree, 1, 1, true);

  return tree;
}; // ==== PRIVATE METHODS =====


TreeFlatten.prototype._flatten = function (treeObject, level, objidFunc, parentId, noLevelProp) {
  var _this = this;

  var list = [];
  if (!level) level = 0;
  if (!treeObject) return [];

  if (level === 0 && treeObject._tree) {
    treeObject = this._removeTreeFields(treeObject, noLevelProp);
  }

  var nextLevel = level + 1;
  if (!objidFunc) objidFunc = this._calcId;

  if (!parentId) {
    parentId = null;
  }

  if (treeObject.constructor === Array) {
    treeObject.map(function (item, idx) {
      var el = _this._updateTreeLevel(item, level, parentId, objidFunc, list.length, noLevelProp);

      list.push(el);

      var sub = _this._flatten(item[_this.treeField], nextLevel, objidFunc, el._tree.id, noLevelProp);

      el._tree.hasknot = sub && sub.length > 0;
      list = list.concat(sub);
    });
  } else {
    var el = this._updateTreeLevel(treeObject, level, parentId, objidFunc, list.length, noLevelProp);

    list.push(el);

    var sub = this._flatten(treeObject[this.treeField], nextLevel, objidFunc, el._tree.id, noLevelProp);

    el._tree.hasknot = sub && sub.length > 0;
    list = list.concat(sub);
  }

  return list;
};

TreeFlatten.prototype._calcId = function (obj, idx) {
  //return "_idx__" + idx;
  return _Utils.default.guid();
};

TreeFlatten.prototype._updateTreeLevel = function (obj, level, parentId, objidFunc, index, noLevelProp) {
  var idx = index !== undefined ? index : 0;
  if (!objidFunc) objidFunc = this._calcId;

  var id = _Utils.default.toId(objidFunc(obj, idx));

  if (obj._tree !== undefined) {//console.debug("object ", obj, " already has a ._tree field/property - OVERWRITE");
    //obj._tree = undefined;
    // delete obj._tree;
  }

  obj._tree = {
    level: level,
    id: id,
    parentId: parentId,
    hasknot: false
  };

  if (!noLevelProp) {
    if (obj.level !== undefined) {
      //console.warn("object ", obj, " already has a .level field/property - OVERWRITE");
      //obj.level = undefined;
      // delete obj.level;
      if (Object.isFrozen(obj)) {
        obj = Object.unfreeze(obj);
      }

      delete obj.level; //Object.undefineProperty
    }

    Object.defineProperty(obj, 'level', {
      configurable: true,
      get: function get() {
        //console.warn("TreeFlatten - UTILIZZO OBSOLETO del campo .level diretto invece del _tree.level")
        return this._tree ? this._tree.level : undefined;
      }
    });
  }

  return obj;
};

TreeFlatten.prototype._removeTreeFields = function (obj, noLevelProp) {
  if (!obj) return null;

  if (Object.isFrozen(obj)) {
    obj = Object.unfreeze(obj);
  } //obj._tree = undefined;


  if (obj._tree !== undefined) {
    // obj._tree = undefined;
    delete obj._tree;
  }

  if (!noLevelProp && obj.level !== undefined) {
    // obj.level = undefined;
    delete obj.level;
  }

  return obj;
};

TreeFlatten.prototype._unflatten = function (list, tree, childrenLevel, startFromIndex, noLevelProp) {
  if (!tree) return startFromIndex;
  var children = [];
  var nextLevel = childrenLevel + 1;
  var lastOk = startFromIndex;
  var prevItem = null;

  for (var i = startFromIndex; i < list.length; i++) {
    var item = list[i];

    if (!item._tree) {
      //console.warn("item", item, " senza campo ._tree");
      continue;
    }

    if (item._tree.level < childrenLevel) {
      break;
    } else if (item._tree.level === childrenLevel) {
      item = this._removeTreeFields(item, noLevelProp);
      children.push(item);
      prevItem = item;
      lastOk = i;
    } else if (item._tree.level === nextLevel) {
      i = this._unflatten(list, prevItem, nextLevel, i, noLevelProp);
    }
  }

  tree[this.treeField] = children;
  return lastOk;
};

var _default = TreeFlatten;
exports.default = _default;